import { SmileIconAnimation } from "@/components/icons/smile-icon-animation";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface TitleSloganProps {
  slogan: string;
}

export const TitleSlogan = memo(function TitleSlogan({ slogan }: TitleSloganProps) {
  return (
    <div className="relative flex w-full items-center gap-6 overflow-visible px-4">
      <SmileIconAnimation />
      <h2 className={cn(textVariants.title2, "flex-1")}>{slogan}</h2>
    </div>
  );
});
